<template>
  <div id="receiveDetail">
    <Loading v-if="loading"></Loading>
    <van-form class="content">
      <van-cell-group inset>
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.scName"
            name="scName"
            label="仓库"
            inputmode="none"
            readonly
        /></van-cell>
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.supplierName"
            name="supplierName"
            inputmode="none"
            label="供应商"
            readonly
        /></van-cell>
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.paymentDate"
            inputmode="none"
            name="paymentDate"
            label="付款日期"
            :readonly="curType === 'detail'"
        /></van-cell>
        <van-cell>
          <van-field
            autocomplete="off"
            v-permission="'purchase:receive:query'"
            v-model="form.purchaseOrderCode"
            name="purchaseOrderCode"
            inputmode="none"
            label="采购订单"
            readonly
          ></van-field>
        </van-cell>

        <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.statusValue"
            name="statusValue"
            label="状态"
            readonly
          ></van-field
        ></van-cell>
        <van-cell v-if="form.refuseReason">
          <van-field
            autocomplete="off"
            v-model="form.refuseReason"
            name="refuseReason"
            label="拒绝理由"
            readonly
        /></van-cell>
        <!-- <van-cell>
          <van-field
            autocomplete="off"
            label="审核人"
            name="approveBy"
            readonly
            v-model:value="form.approveBy"
        /></van-cell>
        <van-cell>
          <van-field
            autocomplete="off"
            label="审核时间"
            name="approveTime"
            v-model:value="form.approveTime"
            readonly
          >
          </van-field
        ></van-cell> -->
      </van-cell-group>
      <van-cell-group inset style="margin-top: 5px">
        <van-cell>
          <van-field
            autocomplete="off"
            v-model="form.description"
            :readonly="curType === 'detail'"
            rows="1"
            autosize
            label="备注"
            type="textarea"
          />
        </van-cell>
      </van-cell-group>
      <van-form style="margin-top: 5px" class="product-list">
        <div class="flex-between top">
          <div>商品列表</div>
          <!-- <div v-if="curType === 'edit'" class="action">
            <Van-icon
              name="add-o"
              type="primary"
              @click="toCategory"
            ></Van-icon>
          </div> -->
        </div>
        <scroll-list
          height="calc(100vh - 500px)"
          :finished="finished"
          :loading="proLoading"
          :error="error"
          @load="onLoad"
          @search="search"
        >
          <van-cell v-for="(item, i) in form.tableData">
            <div class="product" @click="toDetail(item)">
              <div class="flex flex-start">
                <div class="tit">{{ item.productName }}</div>
                <div class="price">
                  <span>￥{{ item.purchasePrice }}</span
                  >/{{ item.unit }}
                </div>
                <div class="desc">
                  剩余可收货数量:{{ item.remainNum || "-" }}
                </div>
              </div>
              <div class="flex flex-end">
                <div class="total">
                  ￥{{ $utils.mul(item.purchasePrice, item.receiveNum) }}
                </div>
                <div>
                  <span v-if="curType === 'detail'">
                    {{ item.receiveNum }}{{ item.unit }}</span
                  >
                  <div v-else class="numChangeBox" @click.stop="">
                    <van-icon
                      class="circleIcon"
                      name="minus"
                      @click="minus($event, i, 'receiveNum')"
                    />
                    <van-field
                      class="numInput"
                      autocomplete="off"
                      type="number"
                      v-model="item.receiveNum"
                    >
                      <template #right-icon>
                        <span v-if="curType !== 'edit'">
                          {{ item.unit }}
                        </span>
                      </template></van-field
                    >
                    <van-icon
                      class="circleIcon"
                      name="plus"
                      @click="plus($event, i, 'receiveNum')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </van-cell>
        </scroll-list>

        <!-- <div v-if="curType != 'detail'" class="action">
          <Van-icon
            name="add-o"
            type="primary"
            @click="showProductSelect = true"
          ></Van-icon>
        </div>
        <CustomTable
          :scrollWidth="600"
          :showPagination="false"
          :columns="columns"
          :tableData="form.tableData"
        ></CustomTable> -->
      </van-form>

      <div style="margin: 16px 0">
        <OrderTimeLine :id="id"></OrderTimeLine>
        <van-form>
          <van-cell>合计</van-cell>
          <van-cell-group>
            <van-cell
              ><van-field
                autocomplete="off"
                label="收货数量"
                readonly
                v-model="form.totalNum"
                type="number"
            /></van-cell>
            <van-cell
              ><van-field
                autocomplete="off"
                label="赠品数量"
                readonly
                type="number"
                v-model="form.giftNum"
            /></van-cell>
            <van-cell
              ><van-field
                autocomplete="off"
                label="含税总金额"
                readonly
                type="number"
                v-model="form.totalAmount"
            /></van-cell>
          </van-cell-group>
        </van-form>

        <van-cell class="actions-btn">
          <van-button
            type="primary"
            @click="toAction('approvePass')"
            round
            :loading="loading"
            v-if="(status == 0 || status == 6) && curType !== 'edit'"
            v-permission="'purchase:receive:approve'"
            >审核通过</van-button
          >
          <van-button
            type="primary"
            @click="toAction('approveRefuse')"
            round
            v-permission="'purchase:receive:approve'"
            :loading="loading"
            v-if="(status == 0 || status == 6) && curType !== 'edit'"
            >审核拒绝</van-button
          >
          <van-button
            type="primary"
            @click="toAction('edit')"
            :loading="loading || proLoading"
            round
            v-if="(status == 0 || status == 6) && curType !== 'edit'"
            v-permission="'purchase:receive:modify'"
            >修改</van-button
          >
          <van-button
            type="warning"
            :loading="loading"
            @click="toAction('del')"
            round
            v-if="(status == 0 || status == 6) && curType !== 'edit'"
            v-permission="'purchase:receive:delete'"
            >删除</van-button
          >
          <van-button
            type="primary"
            :loading="loading || proLoading"
            @click="toAction('confirm')"
            round
            block
            v-if="(status == 0 || status == 6) && curType === 'edit'"
            >保存</van-button
          >
          <van-button
            @click="toAction('close')"
            type="info"
            round
            block
            :loading="loading"
            >关闭</van-button
          >
        </van-cell>
      </div>
    </van-form>
    <van-dialog
      v-model="approveRefuseVisible"
      title="确认弹窗"
      show-cancel-button
      @cancel="cancelApproveRefuse"
      @confirm="confirmApproveRefuse"
    >
      <van-cell title="确认进行审批拒绝操作？"></van-cell>

      <van-cell v-model="refuseReason">
        <van-field
          autocomplete="off"
          v-model="refuseReason"
          rows="2"
          autosize
          type="textarea"
          label="拒绝理由"
        ></van-field>
      </van-cell>
    </van-dialog>
    <!-- <ProductSelect
      :scId="this.form.scId"
      columnsType="checkbox"
      :visible="showProductSelect"
      @confirm="onSelectProductConfirm"
    ></ProductSelect> -->
    <DateTimePicker
      value-format="yyyy-MM-dd"
      :showPicker="showDatePicker"
      @confirm="onDatePickerConfirm"
      @cancel="showDatePicker = false"
    ></DateTimePicker>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { Toast } from "vant";
import Loading from "../../../components/loading.vue";

import CustomTable from "../../../components/customTable.vue";
import OrderTimeLine from "../../../components/orderTimeLine.vue";
import ProductSelect from "../../../components/productSelect.vue";
import DateTimePicker from "../../../components/dateTimePicker.vue";
import {
  getTextByValue,
  PURCHASE_ORDER_STATUS,
} from "../../../utils/constants";
import {
  get,
  update,
  deleteById,
  approvePass,
  approveRefuse,
  getProducts,
} from "../../../service/api/purchase/receive";
import { getOrderTimeLine } from "../../../service/api";
import moment from "moment";

export default {
  name: "index",
  components: {
    CustomTable,
    OrderTimeLine,
    ProductSelect,
    DateTimePicker,
    Loading,
  },
  data() {
    return {
      loading: true,
      finished: false,
      proLoading: true,
      error: false,
      showProductSelect: false,
      refuseReason: "",
      approveRefuseVisible: false,
      status: 0,
      curType: "detail",
      brandSelectVisible: false,
      id: this.$route.params.id,
      showDatePicker: false,
      statusList: [
        { text: "启用", value: "1" },
        { text: "停用", value: "0" },
      ],
      tableData2: [],
      columns: [
        {
          field: "productName",
          key: "productName",
          title: "商品名称",
          width: 100,
          fixed: "left",
        },
        {
          field: "productCode",
          key: "productCode",
          title: "商品编号",
          width: 80,
        },

        { field: "unit", key: "unit", title: "单位", width: 80 },
        { field: "spec", key: "spec", title: "规格", width: 80 },
        {
          field: "productionDate",
          key: "productionDate",
          title: "生产日期",
          width: 130,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const flag = this.curType === "detail";
            const text = row[column.field];
            return flag ? (
              <span>{text}</span>
            ) : (
              <van-field
                autocomplete="off"
                name="productionDate"
                value={text}
                on-click={() => this.openDateTimePicker(rowIndex)}
              ></van-field>
            );
          },
        },
        {
          field: "shelfLifeDays",
          key: "shelfLifeDays",
          title: "保质期时长（天）",
          width: 80,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const flag = this.curType === "detail";
            const text = row[column.field];
            return flag ? (
              <span>{text}</span>
            ) : (
              <van-field
                autocomplete="off"
                name="shelfLifeDays"
                value={text}
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
              ></van-field>
            );
          },
        },
        {
          field: "categoryName",
          key: "categoryName",
          title: "商品类目",
          width: 80,
        },
        {
          field: "isGift",
          key: "isGift",
          title: "是否赠品",
          width: 50,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const text = row[column.field] ? "是" : "否";
            return <span>{text}</span>;
          },
        },
        { field: "brandName", key: "brandName", title: "商品品牌", width: 80 },
        {
          field: "purchasePrice",
          key: "purchasePrice",
          title: "采购价（元）",
          align: "right",
          width: 100,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const flag = this.curType === "detail";
            const text = row[column.field];
            return flag ? (
              <span>{text}</span>
            ) : (
              <van-field
                autocomplete="off"
                name="purchasePrice"
                value={text}
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
                type="number"
              ></van-field>
            );
          },
        },
        {
          field: "taxCostPrice",
          key: "taxCostPrice",
          title: "含税成本价（元）",
          align: "right",
          width: 60,
        },
        {
          field: "stockNum",
          key: "stockNum",
          title: "库存数量",
          align: "right",
          width: 60,
        },
        {
          field: "orderNum",
          key: "orderNum",
          title: "采购数量",
          align: "right",
          width: 100,
        },
        {
          field: "remainNum",
          key: "remainNum",
          title: "剩余收货数量",
          width: 80,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const value = this.$utils.sub(row.remainNum, row.receiveNum);
            return <span>{value}</span>;
          },
        },
        {
          field: "receiveNum",
          key: "receiveNum",
          title: "收货数量",
          width: 100,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const flag = this.curType === "detail";
            const text = row[column.field];
            return flag ? (
              <span>{text}</span>
            ) : (
              <van-field
                autocomplete="off"
                name="receiveNum"
                value={text}
                type="number"
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
              ></van-field>
            );
          },
        },
        {
          field: "taxRate",
          key: "taxRate",
          title: "税率（%）",
          align: "right",
          width: 50,
        },
        {
          field: "purchaseAmount",
          key: "purchaseAmount",
          title: "采购含税金额",
          align: "right",
          width: 80,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const text = row[column.field];
            return (
              <van-field
                autocomplete="off"
                name="purchaseAmount"
                value={text}
                type="number"
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
              ></van-field>
            );
          },
        },
        {
          field: "description",
          key: "description",
          title: "备注",
          width: 80,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const flag = this.curType === "detail";
            const text = row[column.field];
            return flag ? (
              <span>{text}</span>
            ) : (
              <van-field
                autocomplete="off"
                name="description"
                value={text}
                type="number"
                on-input={(val) =>
                  this.inputChange(rowIndex, column.field, val)
                }
              ></van-field>
            );
          },
        },
        {
          field: "",
          key: "e",
          title: "操作",
          width: "",
          center: "left",
          fixed: "right",
          width: 50,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const flag = this.curType === "detail";
            return flag ? (
              ""
            ) : (
              <span class="action">
                <van-icon
                  name="delete-o"
                  on-click={() => this.deleteRow(rowIndex)}
                ></van-icon>
              </span>
            );
          },
        },
      ],
      tableData: [],
      form: {
        id: "",
        name: "",
        retailPrice: "",
        categoryName: "",
        unit: "",
        externalCode: "",
      },
      totalCount: 0,
      pageIndex: 1,
      pageSize: 20,
      index: 0,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.fullPath && from.fullPath !== "/") {
        vm.previousRoute = from.fullPath;
        localStorage.setItem("previousRoute", from.fullPath);
      } else {
        vm.previousRoute = localStorage.getItem("previousRoute");
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    if (
      !to.fullPath.includes("receiveProductModify") &&
      !to.fullPath.includes("/product/category")
    ) {
      localStorage.setItem("orderDetailType", "detail");
    }
    next();
  },
  async mounted() {
    try {
      this.curType = localStorage.getItem("orderDetailType") || "detail";
      let data = {};
      if (
        this.previousRoute &&
        (this.previousRoute.includes("Modify") ||
          this.previousRoute.includes("/product/category")) &&
        this.curType === "edit"
      ) {
        this.orderingKey = "purchaseReceiveing";
        this.curType = "edit";
        data = JSON.parse(localStorage.getItem(this.orderingKey) || "{}");
        this.proLoading = false;
      } else {
        this.loading = true;
        const res = await get(this.id);
        data = res.data;
        this.search();
      }
      if (data.status === 3) {
        this.curType = "detail";
      }
      const newForm = Object.assign(
        {},
        {
          ...data,
          id: data.id,
          scId: data.scId,
          supplierId: data.supplierId,
          purchaserId: data.purchaserId,
          scName: data.scName,
          supplierName: data.supplierName,
          purchaserName: data.purchaserName,
          receiveDate: data.receiveDate,
          description: data.description,
          status: data.status,
          createBy: data.createBy,
          createTime: data.createTime,
          approveBy: data.approveBy,
          approveTime: data.approveTime,
          refuseReason: data.refuseReason,
          totalNum: data.totalNum,
          giftNum: data.giftNum,
          totalAmount: data.totalAmount,
        }
      );
      this.form = { ...newForm };

      this.status = this.form.status;
      this.form.statusValue = isNaN(this.status)
        ? this.status
        : getTextByValue(PURCHASE_ORDER_STATUS, this.status);
      this.status = this.form.status;
      const orderTimeRes = await getOrderTimeLine({ orderId: this.id });
    } catch (error) {
      if (error.isCanceled) return;
      console.error(error);
      this.$router.push("/purchase/receive");
      this.loading = false;
    } finally {
      this.loading = false;
    }
  },
  watch: {
    form: {
      handler(newVal, oldVal) {
        if (this.form.tableData && this.form.tableData.length) {
          this.calcSum();
        }
        if (newVal.purchaseOrderId) {
          localStorage.setItem("purchaseReceiveing", JSON.stringify(newVal));
        }
      },
      immediate: true,
      deep: true,
    },
    curType: {
      handler(newVal, oldVal) {
        if (oldVal || newVal === "edit") {
          localStorage.setItem("orderDetailType", newVal);
        }
      },
      immediate: true,
    },
  },
  methods: {
    onLoad() {
      if (
        this.previousRoute &&
        (this.previousRoute.includes("Modify") ||
          this.previousRoute.includes("/product/category")) &&
        this.curType === "edit"
      ) {
        return;
      }
      this.loading = false;
      this.finished = false;
      this.pageIndex++;
      this.getProductList(true);
    },
    search() {
      if (
        this.previousRoute &&
        (this.previousRoute.includes("Modify") ||
          this.previousRoute.includes("/product/category")) &&
        this.curType === "edit"
      ) {
        return;
      }
      this.pageIndex = 1;
      this.loading = false;
      this.finished = false;
      this.getProductList();
    },
    getProductList(flag = false) {
      this.proLoading = true;
      getProducts({
        id: this.id,
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      })
        .then((res) => {
          const tableData = res.data.datas.map((item) => {
            item.isFixed = !this.$utils.isEmpty(item.purchaseOrderDetailId);
            if (item.isFixed) {
              item.remainNum = this.$utils.add(item.remainNum, item.receiveNum);
            }
            return Object.assign(this.emptyProduct(), item);
          });
          if (flag) {
            this.form.tableData = this.form.tableData ?? [];
            this.form.tableData.push(...tableData);
          } else {
            this.form.tableData = tableData;
          }
          this.finished = !res.data.hasNext;
        })
        .catch((error) => {
          console.error(error);
          this.error = true;
          this.finished = true;
        })
        .finally(() => {
          this.proLoading = false;
        });
    },
    toCategory() {
      this.$router.push({
        path: "/product/category",
        query: { type: "purchaseReceive" },
      });
    },
    toDetail(item) {
      this.$router.push({
        path: "/purchase/receiveProductModify/" + item.productId,
        query: {
          type: this.curType,
        },
      });
    },
    minus(event, i, key) {
      event.stopPropagation();
      if (!this.form.tableData || !this.form.tableData[i][key]) {
        return;
      }
      if (this.form.tableData[i][key] <= 1 && this.form.tableData[i].isFixed) {
        Toast("采购订单中的商品不允许删除");
        return;
      } else if (
        this.form.tableData[i][key] <= 0 &&
        !this.form.tableData[i].isFixed
      ) {
        this.form.tableData.splice(i, 1);
        return;
      }
      let num = this.$utils.preciseSubtraction(
        Number(this.form.tableData[i][key]),
        1
      );
      this.$set(this.form.tableData[i], key, num);
      this.$forceUpdate();
    },
    plus(event, i, key) {
      event.stopPropagation();

      let num = Number(this.form.tableData[i][key]) + 1;
      this.$set(this.form.tableData[i], key, num);
      this.$forceUpdate();
    },
    emptyProduct() {
      return {
        id: this.$utils.uuid(),
        productId: "",
        productCode: "",
        productName: "",
        skuCode: "",
        externalCode: "",
        unit: "",
        spec: "",
        categoryName: "",
        brandName: "",
        purchasePrice: 0,
        taxCostPrice: "",
        stockNum: "",
        orderNum: "",
        remainNum: "",
        receiveNum: "",
        taxRate: "",
        isGift: true,
        taxAmount: "",
        description: "",
        isFixed: false,
        products: [],
      };
    },
    genParams() {
      const params = {
        id: this.id,
        scId: this.form.scId,
        supplierId: this.form.supplierId,
        purchaserId: this.form.purchaserId || "",
        paymentDate: this.form.paymentDate || "",
        receiveDate: this.form.receiveDate,
        purchaseOrderId: this.form.purchaseOrderId,
        description: this.form.description,
        allowModifyPaymentDate: true,
        products: this.form.tableData
          .filter((t) => this.$utils.isFloatGtZero(t.receiveNum))
          .map((t) => {
            const product = {
              productId: t.productId,
              receiveNum: t.receiveNum,
              description: t.description,
              productionDate: t.productionDate,
              shelfLifeDays: t.shelfLifeDays,
              shelfLife: this.addDays(t.productionDate, t.shelfLifeDays),
            };

            if (t.isFixed) {
              product.purchaseOrderDetailId = t.purchaseOrderDetailId;
            }

            return product;
          }),
      };

      return params;
    },

    addDays(date, days) {
      if (!date || !days) {
        return "";
      }
      const result = new Date(date);
      result.setDate(result.getDate() + Number(days));
      return moment(result).format("YYYY-MM-DD");
    },
    inputChange(rowIndex, field, val) {
      this.$set(this.form.tableData, rowIndex, {
        ...this.form.tableData[rowIndex],
        [field]: val,
      });
    },
    onDatePickerConfirm(val) {
      val
        ? this.$set(this.form.tableData, this.index, {
            ...this.form.tableData[this.index],
            productionDate: val,
          })
        : "";
      this.showDatePicker = false;
      this.index = 0;
    },
    openDateTimePicker(index) {
      this.index = index;
      this.showDatePicker = true;
    },
    // 创建/修改订单校验数据
    validData() {
      if (this.$utils.isEmpty(this.form.scId)) {
        this.$utils.createError("仓库不允许为空！");
        return false;
      }

      if (this.$utils.isEmpty(this.form.supplierId)) {
        this.$utils.createError("供应商不允许为空！");
        return false;
      }

      if (this.form.allowModifyPaymentDate) {
        if (this.$utils.isEmpty(this.form.paymentDate)) {
          this.$utils.createError("付款日期不允许为空！");
          return false;
        }
      }

      if (this.$utils.isEmpty(this.form.receiveDate)) {
        this.$utils.createError("实际到货日期不允许为空！");
        return false;
      }

      if (this.$utils.isEmpty(this.form.purchaseOrderId)) {
        this.$utils.createError("采购订单不允许为空！");
        return false;
      }

      if (this.$utils.isEmpty(this.form.tableData)) {
        this.$utils.createError("请录入商品！");
        return false;
      }

      for (let i = 0; i < this.form.tableData.length; i++) {
        const product = this.form.tableData[i];

        if (this.$utils.isEmpty(product.productId)) {
          this.$utils.createError("第" + (i + 1) + "行商品不允许为空！");
          return false;
        }

        if (this.$utils.isEmpty(product.purchasePrice)) {
          this.$utils.createError("第" + (i + 1) + "行商品采购价不允许为空！");
          return false;
        }

        if (!this.$utils.isFloat(product.purchasePrice)) {
          this.$utils.createError("第" + (i + 1) + "行商品采购价必须为数字！");
          return false;
        }
        // if (this.$utils.isEmpty(product.productionDate)) {
        //   this.$utils.createError('第' + (i + 1) + '行商品生产日期不允许为空！');
        //   return false;
        // }
        // if (this.$utils.isEmpty(product.shelfLifeDays)) {
        //   this.$utils.createError('第' + (i + 1) + '行商品保质期不允许为空！');
        //   return false;
        // }
        if (product.isGift) {
          if (parseFloat(product.purchasePrice) !== 0) {
            this.$utils.createError("第" + (i + 1) + "行商品采购价必须等于0！");
            return false;
          }
        } else {
          if (!this.$utils.isFloatGtZero(product.purchasePrice)) {
            this.$utils.createError("第" + (i + 1) + "行商品采购价必须大于0！");
            return false;
          }
        }

        if (!this.$utils.isNumberPrecision(product.purchasePrice, 2)) {
          this.$utils.createError(
            "第" + (i + 1) + "行商品采购价最多允许2位小数！"
          );
          return false;
        }

        if (!this.$utils.isEmpty(product.receiveNum)) {
          if (product.isFixed) {
            if (!this.$utils.isFloatGtZero(product.receiveNum)) {
              this.$utils.createError(
                "第" + (i + 1) + "行商品收货数量不允许小于0！"
              );
              return false;
            }
          } else {
            if (!this.$utils.isTotalNumGtZero(product.receiveNum)) {
              this.$utils.createError(
                "第" + (i + 1) + "行商品收货数量必须大于0并且最多三位小数！"
              );
              return false;
            }
          }

          if (product.isFixed) {
            if (product.receiveNum > product.remainNum) {
              this.$utils.createError(
                "第" +
                  (i + 1) +
                  "行商品累计收货数量为" +
                  (product.orderNum - product.remainNum) +
                  "，剩余收货数量为" +
                  product.remainNum +
                  "，本次收货数量不允许大于" +
                  product.remainNum +
                  "！"
              );
              return false;
            }
          }
        } else {
          if (!product.isFixed) {
            this.$utils.createError(
              "第" + (i + 1) + "行商品收货数量不允许为空！"
            );
            return false;
          }
        }
      }

      if (
        this.form.tableData.filter((item) =>
          this.$utils.isFloatGtZero(item.receiveNum)
        ).length === 0
      ) {
        this.$utils.createError("采购订单中的商品必须全部或部分收货！");
        return false;
      }

      return true;
    },
    calcSum() {
      let totalNum = 0;
      let giftNum = 0;
      let totalAmount = 0;

      this.form.tableData
        .filter((t) => {
          return (
            this.$utils.isFloatGeZero(t.purchasePrice) &&
            this.$utils.isFloatGtZero(t.receiveNum)
          );
        })
        .forEach((t) => {
          const num = parseFloat(t.receiveNum);
          if (t.isGift) {
            giftNum = this.$utils.add(giftNum, num);
          } else {
            totalNum = this.$utils.add(totalNum, num);
          }
          totalAmount = this.$utils.add(
            totalAmount,
            this.$utils.mul(num, t.purchasePrice)
          );
        });

      this.form.totalNum = totalNum;
      this.form.giftNum = giftNum;
      this.form.totalAmount = totalAmount;
    },
    onSelectProductConfirm(row) {
      if (this.showProductSelect) {
        this.showProductSelect = false;
      }
      if (row.length) {
        row.forEach((el) => {
          this.form.tableData.push({
            ...el,
            taxRate: 0,
            taxCostPrice: 0.01,
            stockNum: 1,
            isGift: false,
            productCode: el.code,
            productId: el.id,
            productName: el.name,
            productionDate: "",
            shelfLifeDays: 0,
            shelfLife: "",
            ...el,
          });
        });
      }
    },
    deleteRow(index) {
      this.form.tableData.splice(index, 1);
    },
    confirmApproveRefuse() {
      this.loading = true;
      approveRefuse({
        id: this.id,
        refuseReason: this.refuseReason,
      })
        .then((res) => {
          Toast.success(res.msg);
          this.$router.push({ path: "/purchase/receive" });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    cancelApproveRefuse() {
      this.loading = false;
      this.approveRefuseVisible = false;
      this.refuseReason = "";
    },

    formatter(val) {
      return isNaN(val) ? val : getTextByValue(PURCHASE_ORDER_STATUS, val);
    },
    async toAction(action) {
      let promise = null;
      if (action === "close") {
        if (this.curType === "edit") {
          this.curType = "detail";
          return;
        }
        this.$router.push({ path: "/purchase/receive" });
      } else if (action === "edit") {
        this.curType = "edit";
        return;
      } else if (action === "confirm") {
        this.loading = true;
        //修改校验  todo
        if (!this.validData()) return;
        const params = this.genParams();
        update(params)
          .then((res) => {
            Toast.success(res.msg);
            this.$router.push({ path: "/purchase/receive" });
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (action === "del") {
        this.loading = true;

        Dialog.confirm({
          title: "确认弹窗",
          message: "确定要删除该采购订单吗",
        })
          .then(async () => {
            promise = await deleteById({ id: this.id });
            Toast.success(promise.msg);
            this.$router.push({ path: "/purchase/receive" });
          })
          .catch(() => {
            Toast.fail(promise.msg);
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (action === "approvePass") {
        this.loading = true;
        Dialog.confirm({
          title: "确认弹窗",
          message: "确定要进行审批通过操作",
        })
          .then(async () => {
            promise = await approvePass({
              id: this.id,
            });
            Toast.success(promise.msg);
            this.$router.push({ path: "/purchase/receive" });
          })
          .catch(() => {
            Toast.fail(promise.msg);
          })
          .finally(() => {
            this.loading = false;
          });
      } else if (action === "approveRefuse") {
        this.approveRefuseVisible = true;
      }
    },
  },
};
</script>
<style scoped lang="less">
.van-cell {
  padding: 5px 0px 5px 15px;
}

#receiveDetail {
  position: relative;
  /* height:100vh;
  overflow: auto; */
}

::v-deep .van-field__body {
  height: 100%;
}

.actions-btn {
  .van-button {
    margin: 5px 5px 0 0;
  }
}

.action {
  background-color: #fff;
  padding-left: 20px;
  display: flex;
  align-items: center;
  font-size: 26px;
  height: 36px;
}

.content {
  .product-list {
    background-color: #fff;
    max-height: 60vh;
    overflow: auto;

    .top {
      background-color: #fff;
      padding: 10px;
      font-size: 16px;
    }

    .action {
      background-color: #fff;
      padding-left: 20px;
      display: flex;
      align-items: center;
      font-size: 26px;
      height: 36px;
    }

    .list-con {
      max-height: 300px;
      overflow: auto;
    }
  }

  .product {
    padding-right: 8px;
    font-size: 14px;
    color: #999;
    display: flex;
    width: 100%;
    justify-content: space-between;

    .flex {
      display: flex;
      justify-items: center;
      flex-direction: column;
      align-content: flex-start;
      justify-content: center;
      align-items: flex-start;
    }

    .flex-end {
      align-items: flex-end;
    }

    .tit {
      max-width: 230px;
      font-size: 16px;
      font-weight: 600;
      color: #000;
    }

    .price span {
      font-weight: 500;
      color: #347f5e;
    }

    .total {
      font-weight: 600;
      color: red;
    }
  }
}

.van-cell-group--inset {
  margin: 0px;
  border-radius: 0px;
}
</style>
